import { useState, useCallback } from "react";
import api from "../services/api.js";
import { getApiErrorMessage } from "../utils/commonUtils.js";

const retrieStatusCodes = [503];
const sleep = (ms) => new Promise((res) => setTimeout(res, ms));

const useApi = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const apiRequest = useCallback(
    async ({
      url,
      method = "get",
      data = {},
      params = null,
      headers = {},
      retry = 0,
      retryDelay = 1000,
      ...customConfig
    }) => {
      setLoading(true);
      setError(null);

      let attempt = 0;
      const makeRequest = async () => {
        try {
          const response = await api({
            url,
            method,
            data,
            params,
            headers,
            ...customConfig,
          });
          return response.data;
        } catch (err) {
          const status = err?.response?.status;

          if (attempt < retry - 1 && retrieStatusCodes.includes(status)) {
            attempt++;
            const delay = retryDelay * Math.pow(2, attempt - 1);
            await sleep(delay);
            return makeRequest();
          }

          const errMsg = getApiErrorMessage(err);
          setError(errMsg);
          throw err;
        }
      };
      try {
        return await makeRequest();
      } finally {
        setLoading(false);
      }
    },
    []
  );

  return { apiRequest, loading, error, setError };
};

export default useApi;
